import { isSupportedGoogleFont } from "../../common/font_extractor.es6";

const requested = new Set();

// Loads a supported Google font the first time a shape's text uses it. The
// Visor/SCORM path loads it again through collectTrainingFonts; a duplicate
// <link> for the same URL is harmless.
export function ensureShapeFont(name) {
  if (!name || requested.has(name) || !isSupportedGoogleFont(name)) return;
  if (typeof document === "undefined") return;
  requested.add(name);
  const href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name).replace(
    /%20/g,
    "+"
  )}:ital,wght@0,400;0,700;1,400;1,700&display=swap`;
  if (document.querySelector(`link[href="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}
